import DiceGame from "./components/DiceGame/DiceGame";

function App() {
  return (
    <div className="App">
      <DiceGame></DiceGame>
    </div>
  );
}

export default App;
